import { useComponentInView } from "../../../hooks/useComponentInView";
import useOutputReportStore from "../../../store/OutputReport.store";

import "../staticPageReport.scss";

const StaticPageFour = () => {
  const { ref } = useComponentInView();

  const metadata = useOutputReportStore().metadata;
  const sectionMetadata = metadata?.FirmOverview || {};
  const { sectionKeyKebab } = sectionMetadata;

  if (!metadata?.Cover?.TransitionId) return null;

  return (
    <article
      ref={ref}
      id={`section-${sectionKeyKebab}-4`}
      className="static-page-report report-article"
    >
      <header className="section-title report-article__header">
        <h1>Transition Summary</h1>
      </header>

      <div className="report-article__content">
        <section className="report-article__visual">
          <div className="static-page-report__footnote">
            Investors seeking to transition their existing portfolio in-kind to
            a new managed strategy should be aware of tax liability and risk
            implications. Providing various transition options to reduce risk
            gap (i.e. tracking error) between client's current portfolio and
            target strategy while minimizing tax drag is the primary objective
            of transition analysis. This summary highlights the various
            implementation choices requested by the client by showcasing the
            trade-offs across two critical factors - one, tracking error, a
            measure of closeness of client portfolio to target portfolio; and
            two, tax liability, the tax cost of realizing any embedded capital
            gains in the client portfolio during the transition. By reviewing
            these various implementation choices and understanding the
            trade-offs between tracking error and tax liability, an FA and their
            client can then make an informed decision on how to transition their
            portfolio to the new strategy in an optimal way that suits their
            needs.
            <br />
            <br />
            The total cost basis for each security position and the unrealized
            gain/loss are provided solely for your educational purposes, are not
            guaranteed, and may not be used for tax purposes or otherwise relied
            upon. Tax calculations are only provided for educational purposes,
            are not guaranteed, and should not be relied on for tax purposes.
            Please consult your tax advisor for questions related to the tax
            treatment of your investments. Unrealized gain/loss are based on
            cost basis as provided as is.
            <br />
            <br />
            This report should not be considered investment advice or a
            recommendation to buy or sell any particular security. While every
            effort has been made to verify the information contained herein, we
            make no representations as to its accuracy. The Sample Portfolio is
            for illustrative purposes only and is not meant to represent a
            specific portfolio recommendation or holdings. The information and
            specific securities mentioned are not representative or all
            securities purchased, sold of recommended for advisory clients.
            <br />
            <br />
            Actual portfolio holdings will vary for each client, and there is no
            guarantee that a particular client's accounts will hold any or all
            of the securities listed. It should not be assumed that any of the
            securities, or future recommendations, were or will be profitable.
            The Analysis is current as of the date hereof and is subject to
            change at any time, without prior notice.
            <br />
            <br />
            This Analysis and overall presentation has been prepared by
            Allspring Global Investments for the exclusive use of the Investor
            at the request of such investor or his/her investment
            advisor/consultant. This Analysis has been prepared by Allspring
            Global Investments based on information provided to Allspring by the
            Investor or his/her investment advisor/consultant.
            <br />
            <br />
            There can be no assurance that Allspring will achieve profits or
            avoid incurring losses. Income generated may be subject to the
            alternative minimum tax (AMT) and/or state and local taxes based on
            the investor's state of residence. This Analysis does not
            contemplate the effect of taxes based upon the potential realization
            of capital gains. The information in this report is for illustrative
            purposes only, is subject to change at any time and should not be
            considered a recommendation to purchase or sell any particular
            security. The information is based upon data provided by the
            investor or his/her advisor/consultant.
            <div className="static-page-report__footnote-spacer" />
            <p className="static-page-report__footnote-legend">
              *Existing portfolio information is based on information provided
              in the input questionnaire for the transition analysis. The use of
              incomplete or inaccurate data and information will result in
              different outcomes.
            </p>
            <br />
            <p className="static-page-report__footnote-legend">
              **The transition analysis discussed herein, including sample
              representative portfolio and transition scenarios shown, are
              provided for illustrative purposes only to demonstrate our
              investment capabilities and are subject to change. The sample
              representative portfolio is not maintained as a live composite or
              portfolio at Allspring Global Investments. The information shown
              is not intended to be, nor should it be constructed to be, a
              recommendation to buy or sell an individual security or make any
              investment decision.
            </p>
            <p className="static-page-report__footnote-legal">
              For Investment Professional Use Only In One-On-One Presentation
              With Client
            </p>
          </div>
        </section>
      </div>
    </article>
  );
};

export default StaticPageFour;
